<template>
    <v-card :loading="loading" mx-4>
        <v-skeleton-loader
            v-if="loading"
            type="card"
        ></v-skeleton-loader>
        <v-tabs
            v-else
            v-model="tab"
            background-color="primary"
            dark
        >
            <v-tab key="general">
                Informatii generale
            </v-tab>
            <v-tab v-if="!_.isNil(form.id)" key="file">
                Fisa clientului
            </v-tab>
            <v-tab v-if="!_.isNil(form.id)" key="equipments">
                Echipamente
            </v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
            <v-tab-item key="general">
                <v-card class="px-4 py-4" flat>
                    <v-text-field
                        v-model="form.name"
                        v-validate="'required'"
                        :error-messages="errorMessages('name')"
                        :class="{ 'error--text': hasErrors('name') }"
                        class="primary--text"
                        name="name"
                        label="Denumire"
                        data-vv-as="Denumire"
                        data-vv-name="name"
                        counter="255"
                    />
                    <v-text-field
                        v-model="form.vat_no"
                        v-validate="'required'"
                        :error-messages="errorMessages('vat_no')"
                        :class="{ 'error--text': hasErrors('vat_no') }"
                        class="primary--text"
                        name="vat_no"
                        label="CUI (Cod Unic de Identificare)"
                        data-vv-as="CUI (Cod Unic de Identificare)"
                        data-vv-name="vat_no"
                        counter="255"
                    >
                        <template v-slot:append-outer>
                            <v-btn
                                class="mx-2"
                                fab
                                dark
                                x-small
                                color="primary"
                                @click="searchVatAndFillValues"
                            >
                                <v-icon dark>
                                    mdi-magnify
                                </v-icon>
                            </v-btn>
                        </template>
                    </v-text-field>
                    <v-text-field
                        v-model="form.trade_registry_no"
                        :error-messages="errorMessages('trade_registry_no')"
                        :class="{ 'error--text': hasErrors('trade_registry_no') }"
                        class="primary--text"
                        name="trade_registry_no"
                        label="Numarul Registrul Comertului"
                        data-vv-as="Numarul Registrul Comertului"
                        data-vv-name="trade_registry_no"
                        counter="255"
                    />
                    <v-text-field
                        v-model="form.bank"
                        :error-messages="errorMessages('bank')"
                        :class="{ 'error--text': hasErrors('bank') }"
                        class="primary--text"
                        name="bank"
                        label="Banca"
                        data-vv-as="Banca"
                        data-vv-name="bank"
                        counter="255"
                    />
                    <v-text-field
                        v-model="form.iban"
                        :error-messages="errorMessages('iban')"
                        :class="{ 'error--text': hasErrors('iban') }"
                        class="primary--text"
                        name="iban"
                        label="IBAN"
                        data-vv-as="IBAN"
                        data-vv-name="iban"
                        counter="255"
                    />
                    <v-divider
                        class="mx-4"
                        vertical
                    ></v-divider>
                    <v-subheader>
                        Sediu social
                    </v-subheader>

                    <v-text-field
                        v-model="form.country"
                        v-validate="'required'"
                        :error-messages="errorMessages('country')"
                        :class="{ 'error--text': hasErrors('country') }"
                        class="primary--text"
                        name="country"
                        label="Tara"
                        data-vv-as="Tara"
                        data-vv-name="country"
                    />

                    <v-text-field
                        v-model="form.county"
                        v-validate="'required'"
                        :error-messages="errorMessages('county')"
                        :class="{ 'error--text': hasErrors('county') }"
                        class="primary--text"
                        name="county"
                        label="Judet"
                        data-vv-as="Judet"
                        data-vv-name="county"
                    />

                    <v-text-field
                        v-model="form.city"
                        v-validate="'required'"
                        :error-messages="errorMessages('city')"
                        :class="{ 'error--text': hasErrors('city') }"
                        class="primary--text"
                        name="city"
                        label="Localitate"
                        data-vv-as="Localitate"
                        data-vv-name="city"
                        counter="255"
                    />
                    <v-text-field
                        v-model="form.address"
                        v-validate="'required'"
                        :error-messages="errorMessages('address')"
                        :class="{ 'error--text': hasErrors('address') }"
                        class="primary--text"
                        name="address"
                        label="Strada"
                        data-vv-as="Strada"
                        data-vv-name="address"
                        counter="255"
                    />

                    <v-divider
                        class="mx-4"
                        vertical
                    ></v-divider>
                    <v-subheader>
                        Alte informatii
                    </v-subheader>
                    <v-text-field
                        v-model="form.phone"
                        :error-messages="errorMessages('phone')"
                        :class="{ 'error--text': hasErrors('phone') }"
                        class="primary--text"
                        name="phone"
                        label="Telefon"
                        data-vv-as="Telefon"
                        data-vv-name="phone"
                        counter="255"
                    />
                    <v-text-field
                        v-model="form.contact_phone"
                        :error-messages="errorMessages('contact_phone')"
                        :class="{ 'error--text': hasErrors('contact_phone') }"
                        class="primary--text"
                        name="contact_phone"
                        label="Telefon contact"
                        data-vv-as="Telefon contact"
                        data-vv-name="contact_phone"
                        counter="255"
                    />
                    <v-text-field
                        v-model="form.email"
                        v-validate="'email'"
                        :error-messages="errorMessages('email')"
                        :class="{ 'error--text': hasErrors('email') }"
                        class="primary--text"
                        name="email"
                        label="E-mail"
                        data-vv-as="E-mail"
                        data-vv-name="email"
                        counter="255"
                    />
                    <v-text-field
                        v-model="form.data.contact_person"
                        :error-messages="errorMessages('data.contact_person')"
                        :class="{ 'error--text': hasErrors('data.contact_person') }"
                        class="primary--text"
                        name="data.contact_person"
                        label="Persoana de contact"
                        data-vv-as="Persoana de contact"
                        data-vv-name="data.contact_person"
                        counter="255"
                    />
                    <v-textarea
                        v-model="form.data.remarks"
                        :error-messages="errorMessages('remarks')"
                        :class="{ 'error--text': hasErrors('remarks') }"
                        class="primary--text"
                        name="remarks"
                        label="Observatii"
                        data-vv-as="Observatii"
                        data-vv-name="remarks"
                        counter="255"
                    />

                    <v-btn
                        :loading="form.busy"
                        :disabled="errors.any() || form.busy"
                        block
                        color="success"
                        @click="submit()"
                    >
                        Salveaza
                        <v-icon right>
                            save
                        </v-icon>
                    </v-btn>
                </v-card>
            </v-tab-item>

            <v-tab-item v-if="!_.isNil(form.id)" key="file">
                <offers-component :customer-id="form.id"></offers-component>
            </v-tab-item>

            <v-tab-item v-if="!_.isNil(form.id)" key="equipments">
                <equipments-component :customer-id="form.id"></equipments-component>
            </v-tab-item>
        </v-tabs-items>
    </v-card>
</template>

<script>
    import OffersComponent from 'Components/customers/OffersComponent'
    import EquipmentsComponent from 'Components/customers/EquipmentsComponent'
    import validationError from "Mixins/validation-error";
    import openAPI from "Mixins/openapi";
    import {Form} from "vform";

    export default {
        mixins: [validationError, openAPI],
        components: {
            OffersComponent,
            EquipmentsComponent
        },
        props: {
            id: {
                type: [Number, String],
                required: false
            }
        },
        data: () => ({
            tab: 'general',
            loading: false,
            /* Always Declare Your Form Object */
            form: new Form({
                id: null,
                name: null,
                phone: null,
                contact_phone: null,
                email: null,
                trade_registry_no: null,
                vat_no: null,
                bank: null,
                iban: null,
                country: null,
                county: null,
                city: null,
                address: null,
                data: {
                    contact_person:null,
                    remarks: null
                },
            }),
        }),
        async mounted() {
            if(this.id) {
                await this.loadResource()
            }
        },
        methods: {
            async loadResource() {
                let self = this;
                this.loading = true;

                let { data } = await this.$db.Customer.find(this.id)
                self.form = new Form(data)
                this.loading = false
            },
            async submit() {
                let self = this;
                this.$validator.validateAll().then(result => {
                    if (result) {
                        // eslint-disable-next-line
                        self.createOrUpdate();
                    } else {
                        this.showError()
                    }
                });
            },
            async createOrUpdate() {
                let self = this;
                self.form.busy = true;

                var model = new this.$db.Customer(self.form);
                if (this.id) {
                    model.id = this.id
                }

                model.save()
                    .then(response => {
                        self.$validator.reset();
                        this.showSuccess();
                        self.$nextTick(() => self.$router.push({name: "customers-index"}));
                    })
                    .catch(errors => {
                        self.form.errors.set(this.form.extractErrors(errors.response))
                        this.showError()
                    }).finally(() => {
                    self.form.busy = false;
                });
            },
            async searchVatAndFillValues() {
                await this.searchVatNo(this.form.vat_no)
                    .then(({data}) => {
                        var splicedAddress = this._.get(data, 'adresa', '').split(',')
                        var city = splicedAddress.pop()
                        var address = splicedAddress.join(',')
                        var vatNo = !this._.isNil(data?.tva) ? `RO${data.cif}` : data?.cif
                        this.form = new Form(Object.assign(this.form, {
                            name: data?.denumire,
                            phone: data?.telefon,
                            trade_registry_no: data?.numar_reg_com,
                            vat_no: vatNo,
                            country: 'Romania',
                            county: data?.judet,
                            city: city,
                            address: address
                        }))
                    })
            }
        }
    };
</script>
